import React from 'react';
import { useRecoilState } from 'recoil';
import { baseUnitState } from '@state';

const BaseUnitInput = () => {
  const [baseUnit, setBaseUnit] = useRecoilState(baseUnitState);

  const handleOptionChange = (ev) => {
    setBaseUnit(ev.target.value);
  };

  return (
    <div className="baseUnitInput">
      <label className={baseUnit === 'metric' ? 'isActive' : null}>
        <input type="radio" value="metric" name="baseUnit" checked={baseUnit === 'metric'} onChange={handleOptionChange} />
        <span className="label">mm</span>
      </label>
      <label className={baseUnit === 'imperial' ? 'isActive' : null}>
        <input type="radio" value="imperial" name="baseUnit" checked={baseUnit === 'imperial'} onChange={handleOptionChange} />
        <span className="label">in</span>
      </label>
    </div>
  );
};

export default BaseUnitInput;
